<template>
    <div>
        <div class="columns">
            <div class="column is-7">
                <div class="box">
                    <div class="level">
                        <div class="level-left">
                            <div class="level-item">
                                <div class="field">
                                    <input class="box-info-search input" type="text" v-model="searchText" placeholder="Filter in table">
                                </div>
                            </div>

                            <div class="level-item">
                                <div class="field">
                                    <button class="create-button button" @click="openCloseWeatherChartModal">
                                      <span class="icon is-small">
                                          <i class="fas fa-plus-circle"></i>
                                      </span>
                                        <span>Weather Chart</span>
                                    </button>
                                </div>
                            </div>

                        </div>
                        <div class="level-right">
                            <div class="level-item">
                                <div class="field">
                                    <div class="columns"  style="justify-content: right;">
                                        <div class="column has-text-right">
                                            <div class="tooltip"><font-awesome-icon class="is-size-5 is-warning" icon="info"/>
                                                <div class="tooltiptext">
                                                    <p class="heading">Weather Chart List</p>
                                                    <ul style="list-style: disc outside">
                                                        <li style="margin-left: 20px">
                                                            <p style="margin-bottom: 10px">It is the mapping screen used by the integration.</p>
                                                        </li>
                                                        <li style="margin-left: 20px">
                                                            <p style="margin-bottom: 10px">Images are accessed in response to FIR information received by Jeppesen waypoints.</p>
                                                        </li>
                                                        <li style="margin-left: 20px">
                                                            <p style="margin-bottom: 10px">Image status can be checked via Show.</p>
                                                        </li>
                                                        <li style="margin-left: 20px">
                                                            <p style="margin-bottom: 10px">You can get information about the weather.</p>
                                                        </li>
                                                        <li style="margin-left: 20px">
                                                            <p style="margin-bottom: 10px">You can update the information on the grid</p>
                                                        </li>
                                                        <li style="margin-left: 20px">
                                                            <p style="margin-bottom: 10px">You can delete the information on the grid</p>
                                                        </li>
                                                        <li style="margin-left: 20px">
                                                            <p style="margin-bottom: 10px">You can see the information on the grid.</p>
                                                        </li>
                                                        <li style="margin-left: 20px">
                                                            <p style="margin-bottom: 10px">You can search weather matrix by FIR</p>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="!isLoading" class="weather-matrix-table">
                    <table class="table is-fullwidth is-narrow is-striped is-bordered animate__animated animate__slideInUp">
                        <thead>
                        <tr>
                            <th style="width: 100px">Region Name</th>
                            <th style="width: 60px">FIR</th>
                            <th style="width: 150px">Chart Name</th>
                            <th style="width: 200px">Chart Url</th>
                            <th style="width: 200px">Chart Uri</th>
                            <th style="width: 20px">Chart Order</th>
                            <th style="width: 240px">Act</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="weatherChart in searchWeatherChart" :key="weatherChart.id">
                            <td>{{weatherChart.regionName}}</td>
                            <td>
                                <p v-if="!weatherChart.isEditing">{{weatherChart.fir}}</p>
                               <!-- :selected="region.fir ===weatherChart.regionName" -->
                                <select v-else class="select is-medium"  v-model ="weatherChart.weatherRegionId">
                                    <!-- :selected="weatherChart.fir ===region.fir"-->

                                    <option :selected="weatherChart.fir ===region.fir" v-for="(region) in weatherRegions" :key="region.id" :value="region.id" >
                                        {{region.fir}}
                                    </option>
                                </select>

                            </td>
                            <td>
                                <p v-if="!weatherChart.isEditing">{{weatherChart.chartName}}</p>

                                <select v-else class="select is-medium"  v-model ="weatherChart.idChartType">
                                    <option :selected="weatherChart.chartName === charttype.chartName" v-for="(charttype) in weatherChartTypes" :key="charttype.idChartType" :value="charttype.idChartType">
                                        {{charttype.chartName}}
                                    </option>
                                </select>
                            </td>

                            <td>
                                <p v-if="!weatherChart.isEditing">{{weatherChart.chartUrl}}</p>
                                <input v-else class="input" type="text" v-model="weatherChart.chartUrl">
                            </td>

                            <td>
                                <p v-if="!weatherChart.isEditing">{{weatherChart.chartUri}}</p>
                                <input v-else class="input" type="text" v-model="weatherChart.chartUri">
                            </td>

                            <td>
                                <p v-if="!weatherChart.isEditing">{{weatherChart.chartOrder}}</p>
                                <input v-else class="input" type="text" v-model="weatherChart.chartOrder">
                            </td>

                            <td>
                                <div class="read" v-if="!weatherChart.isEditing">
                                    <button class="button is-small is-light is-info" @click="weatherChartShow(weatherChart.chartUrl,weatherChart.chartUri)">
                                    <span class="icon is-small">
                                        <font-awesome-icon icon="image"/>
                                    </span>
                                        <span>Show</span>
                                    </button>

                                    <button class="button is-small is-light is-info" style="margin-left: 5px;" @click="editButton=true,weatherChart.isEditing=true">
                                        <span class="icon is-small"><font-awesome-icon icon="edit"/></span>
                                        <span>Edit</span>
                                    </button>

                                    <button class="button is-small is-light is-warning" style="margin-left: 5px;" @click="DeleteweatherChart(weatherChart.id,weatherChart.chartUrl,weatherChart.chartUri,weatherChart.weatherRegionId,weatherChart.idChartType,weatherChart.chartOrder)">
                                        <span class="icon is-small"><font-awesome-icon icon="box"/></span>
                                        <span>Delete</span>
                                    </button>

                                </div>

                                <div class="write" v-if="weatherChart.isEditing">

                                    <button class="button is-light is-success"
                                            style="margin-left: 5px;"
                                            @click="editWeatherChart(weatherChart.id,weatherChart.chartUrl,weatherChart.chartUri,weatherChart.weatherRegionId,weatherChart.idChartType,weatherChart.chartOrder),weatherChart.isEditing=false">

                                    <span class="icon is-small">
                                        <font-awesome-icon icon="check"/>
                                    </span>
                                        <span>Save</span>
                                    </button>

                                    <button class="button is-light is-danger"
                                            style="margin-left: 5px;"
                                            @click="editButton=false,weatherChart.isEditing=false">

                                    <span class="icon is-small">
                                         <font-awesome-icon icon="times"/>
                                    </span>

                                        <span>Cancel</span>
                                    </button>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div v-else>
                    <loading-button/>
                </div>
            </div>
            <div class="column is-5">
                <div class="box">
                    <div class="level">
                        <div class="level-left">
                            <div class="level-item">
                                <div class="control">
                                    <p class="heading"> Weather Chart Image (fetched from jetplan.com)</p>

                                </div>
                            </div>
                        </div>
                        <div class="level-right">
                            <div class="level-item">
                                <div class="field">
                                    <font-awesome-icon icon="image" color="#6a85a7" size="3x"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="weather-matrix-image">

                    <div v-if="weatherUrl!=null" class="icon icon-full-screen" @click="openNewTab()">
                        <img src="../../../assets/images/full-screen.svg" class="image is-24x24"/>
                    </div>

                    <embed type="application/pdf"
                           :src="weatherUrl"
                           width="100%" height="100%" alt="pdf"
                           title="CHROME">
                </div>

            </div>
        </div>

                <div class="modal " v-bind:class="{'is-active':isActiveWeatherChartModal}">
                    <div class="modal-background" @click="openCloseWeatherChartModal"></div>
                    <div class="modal-card animate__animated animate__zoomIn animate__faster" style="width:40%; height: 45%;">
                        <header class="modal-card-head">
                            <div class="columns is-fullwidth" >
                                <div class="column is-full">
                                    <p class="modal-card-title">Weather Chart</p>
                                </div>
                                <div class="column is-full">
                                    <div class="field">
                                        <div class="control">
                                            <div class="control">
                                                <button class="create-button button" @click="openCloseWeatherRegionModal">
                                                    <!--<button class="create-button button" @click="tryAdd">-->
                                                    <span class="icon is-small">
                                                        <i class="fas fa-globe"></i>
                                                    </span>
                                                    <span>Add FIR</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="column is-one-fifth">

                                </div>
                                <div class="column is-one-fifth">
                                    <button class="delete is-large" @click="openCloseWeatherChartModal" aria-label="close">Close</button>
                                </div>
                            </div>

                        </header>

                        <section class="modal-card-body" style="width: 100%; height: 100%">
                            <div class="field is-horizontal">
                                <div class="field-label is-normal">
                                    <label class="label">FIR</label>
                                </div>
                                <div class="field-body">
                                    <div class="field">
                                        <div class="control">

                                            <!-- <input class="input" type="text" v-model="WeatherChartForm.fIR">   -->

                                            <select class="select is-medium"  v-model ="WeatherChartForm.WeatherRegionId">
                                                <option v-for="(region) in weatherRegions" :key="region.id" :value="region.id">
                                                    {{region.fir}}
                                                </option>
                                            </select>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="field is-horizontal">
                                <div class="field-label is-normal">
                                    <label class="label">Chart Name</label>
                                </div>
                                <div class="field-body">
                                    <div class="field">
                                        <div class="control">
                                            <!-- <input class="input " type="text" v-model="WeatherChartForm.chartName">    -->
                                            <select class="select is-medium"  v-model ="WeatherChartForm.IDChartType">
                                                <option v-for="(charttype) in weatherChartTypes" :key="charttype.idChartType" :value="charttype.idChartType">
                                                    {{charttype.chartName}}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="field is-horizontal">
                                <div class="field-label is-normal">
                                    <label class="label">Chart Url</label>
                                </div>
                                <div class="field-body">
                                    <div class="field">
                                        <div class="control">
                                           <input  class="input" type="text" v-model="WeatherChartForm.chartUrl">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="field is-horizontal">
                                <div class="field-label is-normal">
                                    <label class="label">Chart Uri</label>
                                </div>
                                <div class="field-body">
                                    <div class="field">
                                        <div class="control">
                                            <input  class="input" type="text" v-model="WeatherChartForm.chartUri">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="field is-horizontal">
                                <div class="field-label is-normal">
                                    <label class="label">Chart Order</label>
                                </div>
                                <div class="field-body">
                                    <div class="field">
                                        <div class="control">
                                            <input class="input" type="text" v-model="WeatherChartForm.ChartOrder">
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </section>

                        <footer class="modal-card-foot">

                            <div class="field">
                                <div class="control">
                                    <div class="control">
                                        <button class="create-button button" @click="TryAddWeatherChart(WeatherChartForm)">
                                          <span class="icon is-small">
                                             <i class="fas fa-save"></i>
                                          </span>
                                            <span>Save</span>
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </footer>

                    </div>
                </div>

                    <div class="modal " v-bind:class="{'is-active':isActiveWeatherRegionModal}">
                    <div class="modal-background" @click="openCloseWeatherRegionModal"></div>
                    <div class="modal-card animate__animated animate__zoomIn animate__faster" style="width:40%; height: 70%;">
                        <header class="modal-card-head">
                            <p class="modal-card-title">Weather Region</p>
                            <button class="delete is-large" @click="openCloseWeatherRegionModal" aria-label="close">Close</button>
                        </header>

                        <section class="modal-card-body" style="width: 100%; height: 100%">

                            <!-- Region Name -->
                            <div class="field is-horizontal">
                                <div class="field-label is-normal">
                                    <label class="label">Region Name</label>
                                </div>
                                <div class="field-body">
                                    <div class="field">
                                        <div class="control">
<!--                                            <input v-if="WeatherRegion.id != null" class="input " type="text" v-model="WeatherRegion.RegionName">-->
                                            <input class="input" type="text" v-model="WeatherRegionForm.RegionName">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- FIR -->
                            <div class="field is-horizontal">
                                <div class="field-label is-normal">
                                    <label class="label">FIR</label>
                                </div>
                                <div class="field-body">
                                    <div class="field">
                                        <div class="control">
<!--                                            <input v-if="WeatherRegion.id != null" class="input " type="text" v-model="WeatherRegion.FIR">-->
                                            <input class="input " type="text" v-model="WeatherRegionForm.FIR">

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Save Button -->
                            <div class="field">
                                <div class="control">
                                    <div class="control">
                                        <button class="create-button button" @click="AddWeatherRegion(WeatherRegionForm)">
                                          <span class="icon is-small">
                                             <i class="fas fa-save"></i>
                                          </span>
                                            <span>Save</span>
                                        </button>
                                    </div>
                                </div>
                            </div>

                        <hr>

                        <table class="table is-fullwidth is-narrow is-striped is-bordered animate__animated animate__slideInUp ">
                                <thead>
                                <tr>
                                    <th style="width: 45px">Id</th>
                                    <th style="width: 80px">Region Name</th>
                                    <th style="width: 60px">FIR</th>
                                    <th style="width: 100px">ACT</th>
                                </tr>
                                </thead>
                                <tbody>


                                <tr v-for="region in weatherRegions" :key="region.id">
                                    <td>{{region.id}}</td>

                                    <td>
                                        <p v-if="!region.isEditing"> {{region.regionName}} </p>
                                        <input v-else class="input" type="text" v-model="region.regionName">
                                    </td>

                                    <td>
                                        <p v-if="!region.isEditing">{{region.fir}}</p>
                                        <input v-else class="input" type="text" v-model="region.fir">
                                    </td>

                                    <td>
                                        <div class="read" v-if="!region.isEditing">

                                            <button class="button is-small is-light is-info" style="margin-left: 5px;"  @click="GetTrueRegionButtonIsEditing(region)">
                                                <span class="icon is-small"><font-awesome-icon icon="edit"/></span>
                                                <span>Edit</span>
                                            </button>





                                        </div>
                                        <div class="write" v-else>

                                            <button class="button is-light is-success"
                                                    style="margin-left: 5px;"
                                                    @click="UpdateWeatherRegion(region)"> <!-- ,region.isEditing=false-->

                                            <span class="icon is-small">
                                                <font-awesome-icon icon="check"/>
                                            </span>
                                                <span>Save</span>
                                            </button>

                                            <button class="button is-light is-warning"
                                                    style="margin-left: 5px;"
                                                    @click="DeleteWeatherRegion(region)"> <!-- ,region.isEditing=false-->
                                                <span class="icon is-small">
                                                <font-awesome-icon icon="box"/>
                                            </span>
                                                <span>Delete</span>
                                            </button>

                                            <!--
                                            <button class="button is-small is-light is-warning" style="margin-left: 5px;" @click="deleteRegionButton=true,region.isCreating=true">
                                                <span class="icon is-small"><font-awesome-icon icon="box"/></span>
                                                <span>Delete</span>
                                            </button>
                                            -->

                                            <button class="button is-light is-danger"
                                                    style="margin-left: 5px;"
                                                    @click="GetFalseRegionButtonIsEditing(region)">

                                            <span class="icon is-small">
                                                 <font-awesome-icon icon="times"/>
                                            </span>
                                                <span>Cancel</span>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>

                        </section>

                        <footer class="modal-card-foot">



                        </footer>
                    </div>
                </div>

    </div>
</template>

<script>
    import {createNamespacedHelpers} from "vuex";
    import WeatherMatrixService from "../../../services/weathermatrix.service";
    import {loadingMixin} from "../../../utils/mixins";
    import LoadingButton from "../../../components/ui/LoadingButton";

    const {mapState, mapActions} = createNamespacedHelpers('weathermatrix');

    export default {
        name: "WeatherMatrix",

        mixins: [loadingMixin],

        components: {
            LoadingButton,
        },

        data() {
            return {
                weatherUrl: null,
                editButton: false,
                editButtonId: null,
                editRegionButtonId: null,
                editRegionButton :false,
                deleteRegionButton:false,
                selectedChartNameId :null,
                selectedFIRRegionId :null,
                weatherChartUri: "",
                weatherChartUrl: "",
                searchText: "",
                editForm: {
                    WeatherRegionId : 0,
                    chartUrl: "",
                    chartUri: "",
                    IdChartType : 0,
                    ChartOrder : 0,
                    IsDelete : false,
                },

                WeatherChartForm:{
                    id: 0,
                    FIR:'',
                    ChartName:'',
                    IDChartType:0,
                    ChartUrl:'',
                    ChartUri:'',
                    ChartOrder : 0
                },

                WeatherChart:{
                    id: 0,
                    FIR:'',
                    ChartName:'',
                    ChartUrl:'',
                    ChartUri:'',
                    ChartOrder : 0
                },

                WeatherRegionForm:{
                    id: 0,
                    RegionName:'',
                    FIR:'',
                },

                WeatherRegion:{
                    id: 0,
                    RegionName:'',
                    FIR:'',
                },

            }
        },

        methods: {
            ...mapActions(["getWeatherChart", "patchWeatherChart","openCloseWeatherChartModal","openCloseWeatherRegionModal","GetAllWeatherChartTypes","GetAllWeatherRegions"]),

            weatherChartShow(url, uri) {
                this.weatherUrl = url + uri;
            },

            openCloseModal()
            {

            },

            async TrygetWeatherChart() {
                this.showLoading();
                try {
                    await this.getWeatherChart();
                } catch (e) {
                    this.$notify({title: "Error", text: "Error on TrygetWeatherChart e: "+ e.message, type: "error"});
                } finally {
                    this.hideLoading();
                }
            },

            GetTrueRegionButtonIsEditing(region)
            {
                this.editRegionButton=true; region.isEditing=true;
            },

            GetFalseRegionButtonIsEditing(region)
            {
                // editRegionButton=false,region.isEditing=false
                this.editRegionButton=false; region.isEditing=false;
            },

            async editWeatherChart(id, url, uri,FIRid,ChartNameid,chartOrder) {

                this.editForm.chartUrl = url;
                this.editForm.chartUri = uri;
                this.editForm.WeatherRegionId = FIRid;
                this.editForm.IdChartType = ChartNameid;
                this.editForm.ChartOrder = chartOrder;
                this.editForm.IsDelete = false;
                try {
                    await WeatherMatrixService.SetWeatherPatch(id, this.editForm);
                    this.$notify({title: "Success", text: "Successfully updated", type: "success"})



                    this.editButtonId = null
                } catch (e) {
                    this.$notify({title: "Error", text: "Error on editWeatherChart function e: "+e.message, type: "error"})
                }
                finally {
                    await this.TrygetWeatherChart();
                }

            },

            async DeleteweatherChart(id, url, uri,FIRid,ChartNameid,chartOrder)
            {

                this.editForm.chartUrl = url;
                this.editForm.chartUri = uri;
                this.editForm.WeatherRegionId = FIRid;
                this.editForm.IdChartType = ChartNameid;
                this.editForm.ChartOrder = chartOrder;
                this.editForm.IsDelete = true;
                try {

                    await this.$swal({
                        title: '<p style="text-align: left;font-size: 22px;">Do you want to delete Weather Chart?</p>',
                        html: "",
                        showCancelButton: true,
                        cancelButtonText: 'No',
                        cancelButtonColor: '#C5381A',
                        confirmButtonColor: '#1874DA',
                        confirmButtonText: 'Yes',
                    }).then(async(response) =>
                    {
                        if (response.value)
                        {
                            await WeatherMatrixService.SetWeatherPatch(id, this.editForm);
                            this.$notify({
                                title: "Success",
                                text: "WeatherChart is deleted.",
                                type: "success"
                            });
                            await this.TrygetWeatherChart();
                        }
                    });
                    //await WeatherMatrixService.SetWeatherPatch(id, this.editForm);
                    this.editButtonId = null
                } catch (e) {
                    this.$notify({title: "Error", text:"Error on DeleteweatherChart function e: " + e.message , type: "error"})
                }

            },

            async TryAddWeatherChart(WeatherChartForm)
            {
                try {
                    await WeatherMatrixService.SetWeatherPatch(0, WeatherChartForm);
                    this.$notify({title: "Success", text: "Successfully updated", type: "success"})
                    this.editButtonId = null
                    this.clearWeatherChartForm();
                } catch (e) {
                    this.$notify({title: "Error", text:"Error on TryAddWeatherChart function e: "+ e.message, type: "error"})
                }
                finally {
                    await this.TrygetWeatherChart();
                }
            },

            clearWeatherChartForm()
            {
                this.WeatherChartForm={
                    id: 0,
                        FIR:'',
                        ChartName:'',
                        IDChartType:0,
                        ChartUrl:'',
                        ChartUri:'',
                        ChartOrder : 0
                }


            },



            async AddWeatherRegion(WeatherRegionForm)
            {

                var IsDelete = 0
                var errline = ""
                var fir = WeatherRegionForm.FIR
                var regionName = WeatherRegionForm.RegionName

                try{
                    errline = "FirInsertOrUpdate"

                    await WeatherMatrixService.FirInsertOrUpdate(0,fir,regionName,IsDelete);

                    errline = "GetAllWeatherRegions"
                    await this.GetAllWeatherRegions();
                    errline = "GetAllWeatherChartTypes"
                    await this.GetAllWeatherChartTypes();
                    errline = "TrygetWeatherChart"
                    await this.TrygetWeatherChart();

                    this.$notify({title: "Success", type: "success", text:"Weather Region added." })
                }
                catch (e) {
                    this.$notify({title: "Error", type: "error", text:"Error on Weather Region Add, "+errline+" function e: " + e.message})
                }
                finally {
                    this.ClearWeatherRegionForm();
                }




            },

            async UpdateWeatherRegion(WeatherRegionForm)
            {
                var IsDelete = 0
                var errline = ""
                try{
                    errline = "FirInsertOrUpdate"
                    await WeatherMatrixService.FirInsertOrUpdate(WeatherRegionForm.id,WeatherRegionForm.fir,WeatherRegionForm.regionName,IsDelete);
                    errline = "GetAllWeatherRegions"
                    await this.GetAllWeatherRegions();
                    errline = "GetAllWeatherChartTypes"
                    await this.GetAllWeatherChartTypes();
                    errline = "TrygetWeatherChart"
                    await this.TrygetWeatherChart();
                }
                catch (e) {
                    this.$notify({title: "Error", type: "error", text:"Error on Weather Region Update, "+errline+" function e: " + e.message})
                }


            },

            ClearWeatherRegionForm()
            {
                this.WeatherRegionForm={
                    id: 0,
                        RegionName:'',
                        FIR:'',
                }
            },

            async DeleteWeatherRegion(WeatherRegionForm)
            {
                var IsDelete = 1
                var errline = ""
                try{
                    errline="FirInsertOrUpdate"
                    await WeatherMatrixService.FirInsertOrUpdate(WeatherRegionForm.id,WeatherRegionForm.fir,WeatherRegionForm.regionName,IsDelete);
                    errline="GetAllWeatherRegions"
                    await this.GetAllWeatherRegions();
                    errline="GetAllWeatherChartTypes"
                    await this.GetAllWeatherChartTypes();
                    errline="TrygetWeatherChart"
                    await this.TrygetWeatherChart();

                    this.$notify({title: "Success", type: "success", text:"Weather Region deleted." })
                }
                catch (e) {
                    this.$notify({title: "Error", type: "error", text:"Error on Weather Region delete, "+errline+" function e: " + e.message})
                }


            },

            openNewTab() {
                window.open(this.weatherUrl, 'Image', 'resizable=1');
            }

        },

        computed: {
            ...mapState(["weatherChartList","isActiveWeatherRegionModal","isActiveWeatherChartModal","weatherChartTypes","weatherRegions"]),
            searchWeatherChart: function () {
                return this.weatherChartList.filter((post) => {
                    return post.fir.match(this.searchText.toUpperCase());
                })
            },
        },




        async mounted() {
            await this.TrygetWeatherChart();
        },

        async created() {
            // this.getWeatherChart();
            try {
                await this.GetAllWeatherRegions();
            }
            catch (e) {
                this.$notify({title: "Error", type: "error", text:"Error on GetAllWeatherRegions function e: " +e.message});
            }

            try {
                await this.GetAllWeatherChartTypes();
            }
            catch (e) {
                this.$notify({title: "Error", type: "error", text:"Error on GetAllWeatherChartTypes function e: " +e.message});
            }


        }

    }
</script>

<style scoped>

    .weather-matrix-table thead th {
        color: white;
        background-color: #6a85a7;
        font-style: normal;
        font-size: 20px;
        top: -12px;
        position: sticky;
        z-index: 2;
    }

    .weather-matrix-table td {
        border: 0px;
    }

    .weather-matrix-table {
        overflow-y: scroll;
        height: 780px;
    }

    .weather-matrix-table th {
        top: -12px;
        positiairports-tableon: sticky;
        background-color: white;
        z-index: 2;
    }

    .create-button {
        background-color: #6a85a7;
        color: white;
        font-size: 10px;
        font-size: 1.1rem;
        min-height: auto;
    }

    .box {
        height: 80px;
    }

    .icon-full-screen {
        margin-top: -5px;
        margin-bottom: 5px;
        cursor: pointer;
        float: right;
    }

    .icon-full-screen:hover {
        box-shadow: 0 0 30px 5px rgba(0, 0, 0, 0.1);
        transform: scale(1.02);
        background-color: whitesmoke;
    }

    .weather-matrix-image {
        height: 780px;
    }

    figure {
        max-height: 780px;
    }

    ::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
        background-color: #F5F5F5;
    }

    ::-webkit-scrollbar {
        height: 2px;
        width: 8px;
        background-color: #F5F5F5;
    }

    ::-webkit-scrollbar-thumb {
        background-color: #6a85a7;
    }

    .tooltip {
        position: relative;
        display: inline-block;
    }

    .tooltip .tooltiptext {
        visibility: hidden;
        min-width: 400px;
        max-width: 420px;
        background-color: #6a85a7de;
        border:3px solid;
        border-color: #4f4f4f;
        color: #fff;
        border-radius: 6px;
        top: 100%;
        left: 50%;
        margin-left: -366px;
        padding: 10px;
        margin-right: 23px;
        margin-top: 13px;
        font-size: 15px;
        text-align: left;

        /* Position the tooltip */
        position: absolute;
        z-index: 1111;
    }

    .tooltip:hover .tooltiptext {
        visibility: visible;
    }


</style>
